export default __webpack_public_path__ + "static/media/resources.076d6447.svg";